import { useState } from "react";
import { ExternalLink } from "lucide-react";

const APPS = [
  ["spotify", "Spotify", (q) => `https://open.spotify.com/search/${encodeURIComponent(q)}`],
  ["apple", "Apple Music", (q) => `https://music.apple.com/us/search?term=${encodeURIComponent(q)}`],
  ["youtube", "YouTube Music", (q) => `https://music.youtube.com/search?q=${encodeURIComponent(q)}`],
];

export const MusicHandoff = () => {
  const [song, setSong] = useState("");
  const q = song.trim();
  return (
    <section className="pp-card mt-8" data-testid="music-handoff">
      <p className="pp-label">Asked nicely? Now play it for real</p>
      <h2 className="pp-h2">Open your song in a music app</h2>
      <p className="opacity-75 mt-1">Type the song you asked for, then pick an app. A grown-up may need to be signed in.</p>
      <input className="pp-input pp-auth-input" value={song} onChange={(e) => setSong(e.target.value)}
        placeholder="e.g. Here Comes the Sun" data-testid="music-song-input" />
      <div className="flex flex-wrap gap-2 mt-4">
        {APPS.map(([id, label, url]) => (
          <a key={id} href={q ? url(q) : undefined} target="_blank" rel="noopener noreferrer"
            className={`pp-ghost ${q ? "" : "pointer-events-none opacity-50"}`} aria-disabled={!q} data-testid={`music-open-${id}`}>
            <ExternalLink className="h-4 w-4" /> {label}
          </a>
        ))}
      </div>
    </section>
  );
};
